import classNames from "classnames";
import styles from "./ChatNav.module.scss";
import { Link } from "react-router-dom";
import CutsomButton from "components/Button";

import { RoutePaths } from "pages/routePaths";
import styled from "styled-components";
import { useWindowSize } from "hooks/useWindowSize";
import { Credits } from "./components/Credits";

import { useSelector } from "redux/hooks";

import useRouter from "hooks/useRouter";
import { FormattedMessage } from "react-intl";
import { SetStateAction, Dispatch, useState } from "react";
import { Setting } from "./icons/setting";
import {
  clearhistoryMessages, startNewChat, ICRWorkSpace, IChat, IWorkspace, setUpdatedName, UpdateThTitle, UpdateWorkspace, SaveSelectedThread, setIsEditing,
  updateChatHistory, setRememberChatTopic, deleteSingleChatHistory, removeMultipleChat, DeleteS3Link,
  setPrivateChat,EmptyChatContent
} from "redux/actions";
import { useToggleSidebar } from "hooks/services/ToggleSidebarProvider";
import { WordspaceEditIcon } from "pages/Workspaces/components/icons/RightSectionIcon";
import { RemoveIcon, TickIcon } from "views/layout/Sidebar/component/ChatSidebar/components/icons";
import { Spinner } from "components";
import { useAppNotification } from "hooks/services/AppNotification";
import { Loader } from "components/Loader";
import { SaveThreadInfo } from "utils/constants";
import { IncognitoMode } from "./icons/IncognitoMode";
import { useThreadsHistoryContext } from "hooks/ThreadHistoryContext";

import { removeQuotes } from "utils/functions";
import { AlertNotification } from "./components/AlertNotification/AlertNotification";
import { useSidebar } from "hooks/services/ReSizeSidebar";

interface IProps {
  isMainScreenOpen?: boolean;
  toggleChatModelsModel?: () => void;
  setChatSetting?: Dispatch<SetStateAction<boolean>>;
  chatItem?: IChat;
  fileS3Link?: string[];
}

const Button = styled(CutsomButton)`
  display: none;
  padding : 5px 40px ;
  @media screen and (min-width: 769px) {
    display: inline-flex;
  }
`;

const WorkspaceName = styled.span`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  min-width: 0;
  max-width: max-content;
  width: fit-content;
  flex-shrink: 1;
`;

const WorkspaceWrapper = styled.div<{maxwidth?: boolean, IsChat?: boolean}>`
  display: flex;
  align-items: center;
  gap: 15px;

  max-width: ${({ maxwidth, IsChat }) => maxwidth? "37%": IsChat? "100%" : "auto"};
  // min-width: 0;

  @media (max-width: 860px) {
  //  max-width: 28%;
  }
`;

export const ChatNav = ({
  setChatSetting,
  fileS3Link,
}: IProps) => {

  const { onChangeChat, } = useThreadsHistoryContext();
  const { isOpen } = useToggleSidebar();
  const { push, includeRoute, pathname } = useRouter();
  const { width } = useWindowSize();
  const { theme, userDetail } = useSelector((state) => state.authReducer);
  const { newMessages, PrivateChat, RememberTopic, loadChatTopic } = useSelector((state) => state.chatReducer);
  const isShare = window.location.pathname.includes("share-chat");
  const lang = userDetail?.user?.language ? userDetail?.user?.language : "en";
  const Id = pathname.split("/")[2];
  const { triggerNotification } = useAppNotification();
  const { currentConversation, selectedThread, loadTopicInfo, isEditing, searchWsQuery, isSearchActive } = useSelector((state) => state.workSpaceReducer);
  const pathParts = pathname.split("/").filter(Boolean);
  // Parse path to determine which component to render
  const isWorkspacePath = pathParts[0] === "workspaces";
  const hasThreadId = pathParts.includes("thread") && pathParts.length > pathParts.indexOf("thread") + 1;
  const currentPath = window.location.pathname;
  const pathSegments = currentPath.split("/");
  const chatId = pathSegments[pathSegments.length - 2];
  // const chatId = pathname.split("/")[3];
  const renderThreadsContent = isWorkspacePath && hasThreadId;

  const [workspaceName, setWorkspaceName] = useState<string>(renderThreadsContent ? selectedThread.thread_name : RememberTopic ? RememberTopic : currentConversation?.name ?? "");
  const [isLoading, setIsLoading] = useState(false);
  const workSpace = pathname.includes("/thread");
  const isHome = pathname.includes("/workspaces/new");
  const isChat = pathname.includes("/chat");
  const { sidebarWidth } = useSidebar();
  const isWorkspaceWithId = /^\/workspaces\/(?!new$)[^/]+$/.test(pathname);
  const freeTrial = userDetail?.user?.activeSubscription?.name === "Free";

  const handleEditClick = () => {
    if (isChat && RememberTopic) {
      setWorkspaceName(removeQuotes(RememberTopic));
      setIsEditing(true);
    } else if (renderThreadsContent || newMessages?.length > 0) {
      setWorkspaceName(removeQuotes(selectedThread.thread_name));
      setIsEditing(true);
    } else if (currentConversation) {
      setWorkspaceName(removeQuotes(currentConversation.name));
      setIsEditing(true);
    }
  };

  const handleInputChange = (event: any) => {
    setWorkspaceName(event.target.value);
  };

  const handleEdit = () => {
    setIsLoading(true);  // Set loading state to true
    if (isChat && RememberTopic) {
      setIsLoading(true);
      updateChatHistory(Number(chatId), workspaceName, 0)
        .then((resp: any) => {
          setIsLoading(false);
          setIsEditing(false);
          setRememberChatTopic(workspaceName);
          triggerNotification({ message: resp.message, type: "info" });
        })
        .catch((err) => {
          setIsLoading(false);
          triggerNotification({ message: err?.data?.message, type: "error" });
        });
    }
    else if (renderThreadsContent || newMessages?.length > 0) {
      UpdateThTitle(selectedThread.thread_id, { topic: workspaceName })
        .then((response: any) => {
          setIsLoading(false);
          setIsEditing(false);
          triggerNotification({ message: response, type: "info" });
        })
        .catch((err: any) => {
          setIsLoading(false);
          const errorMessage = err?.data?.message || "An unexpected error occurred.";
          triggerNotification({ message: errorMessage, type: "error" });
        })

    } else if (currentConversation) {
      UpdateWorkspace(currentConversation.id, { name: workspaceName })  // API call with the updated name
        .then((response) => {
          const res = response as ICRWorkSpace;
          const updatedData = res.data as IWorkspace
          setUpdatedName(updatedData.name, updatedData.description, updatedData.instructions, updatedData.id);
          setIsLoading(false);
          setIsEditing(false);
          triggerNotification({ message: res.message, type: "info" });
        })
        .catch((err) => {
          setIsLoading(false);
          console.error(err); // Log the error for debugging
          const errorMessage = err?.data?.message || "An unexpected error occurred.";
          triggerNotification({ message: errorMessage, type: "error" });
        })
    }
  }


  const handleRedirectBack = () => {
    if (renderThreadsContent || (newMessages.length > 0 && workSpace)) {
      SaveSelectedThread(SaveThreadInfo);
      startNewChat();
      EmptyChatContent();
      clearhistoryMessages();
      push(`/${RoutePaths.Workspaces}/${renderThreadsContent ? selectedThread.ws_id : Id}`)
    }
    else push(`/${RoutePaths.Workspaces}`)
    setIsEditing(false);
  }

  const getTimeBasedGreeting = () => {
    const currentHour = new Date().getHours();

    if (currentHour >= 5 && currentHour < 12) {
      return <FormattedMessage id="chatpage.greeting.morning" defaultMessage="Good morning" />;
    } else if (currentHour >= 12 && currentHour < 18) {
      return <FormattedMessage id="chatpage.greeting.afternoon" defaultMessage="Good afternoon" />;
    } else if (currentHour >= 18 && currentHour < 22) {
      return <FormattedMessage id="chatpage.greeting.evening" defaultMessage="Good evening" />;
    } else {
      return <FormattedMessage id="chatpage.new.heading" />;
    }
  };

  const getFirstName = (fullName: string | undefined) => {
    if (!fullName) return "";
    return fullName.split(" ")[0];
  };
  const handleDeleteS3Link = () => {
    fileS3Link?.map((file) => {
      DeleteS3Link(file);
    });
  };
  const handleIncognitoMode = () => {
    const currentPath = window.location.pathname;
    const pathSegments = currentPath.split("/");
    const chatIdFromUrl = pathSegments[pathSegments.length - 2];

    if (Number(chatIdFromUrl)) {
      deleteSingleChatHistory(Number(chatIdFromUrl));
      removeMultipleChat([Number(chatIdFromUrl)]);
      sessionStorage.removeItem("privateChatActive");
      sessionStorage.removeItem("PrivateChatId");
    }

    sessionStorage.setItem("privateChatActive", JSON.stringify(true));
    localStorage.setItem("previousPrivateChat", JSON.stringify(true));
    handleDeleteS3Link();
    push(`/${RoutePaths.Home}`);
    startNewChat();
    onChangeChat?.();
    setPrivateChat(false);
  };

   const displayDetail = (!(
    (sidebarWidth > 238 && width <= 1290) ||
     (sidebarWidth > 367 && width <= 1533 && freeTrial) ||
     (sidebarWidth > 320 && width > 1500 && freeTrial) ||
       (sidebarWidth > 240 && width < 1500 && width > 1260 && freeTrial) ||
    (sidebarWidth > 270 && width <= 1300) ||
    (sidebarWidth > 497 && width <= 1323) ||
    (sidebarWidth > 340 && width <= 1460) ||
    (sidebarWidth > 300 && width <= 1420) ||
    (sidebarWidth > 400 && width <= 1578) ||
    (sidebarWidth > 506 && width > 1500) ||
    (sidebarWidth > 480 && width <= 1305) ||
    width < 1100
  ) ) &&  (width > 1200) && !isEditing &&
    (!isWorkspaceWithId ) &&
    !workSpace ;

  return (
    <>
      {isShare && (
        <div className={classNames(styles.LogoContainer, "flex items-center")}>
          <Link
            to="/"
            className={styles.headerLogo}
            data-testid="share-header-logo"
          >
            <img src={`/logo-${theme}.svg`} alt="deftGPT logo" />
          </Link>
          {width > 1020 && (
            <div
              className={classNames(styles.multipleaiModel, {
                [styles.light]: theme === "light",
                [styles.dark]: theme === "dark",
              })}
            >
              - Chat with multiple AI models
            </div>
          )}
        </div>
      )}

      <div className={classNames("font-inter flex gap-[16px] items-center w-[80%]", styles.LogoContainer, {
        [styles.sidebarClose]: !isOpen,
      })}>

        {isHome && (
          (searchWsQuery || isSearchActive) ? (<div
            className={classNames("font-inter", styles.GrettingStyle, {
              [styles.light]: theme === "light",
              [styles.dark]: theme === "dark",
              [styles.sidebarClose]: !isOpen,
            })}
          > <span><FormattedMessage id="workspace.search" /><span>&nbsp;"{searchWsQuery}"</span></span></div>) : (
            <div
              className={classNames("font-inter", styles.GrettingStyle, {
                [styles.light]: theme === "light",
                [styles.dark]: theme === "dark",
                [styles.sidebarClose]: !isOpen,
              })}
            >
              <span> {getTimeBasedGreeting()},{" "}
                {userDetail?.user?.name && (
                  <span>&nbsp;{getFirstName(userDetail.user.name)}</span>
                )}
              </span>
            </div>
          )
        )}

        {PrivateChat &&
          <div className={classNames("cursor-pointer font-inter", styles.WorkSpace, {
            [styles.sidebarClose]: !isOpen,
            [styles.light]: theme === "light",
            [styles.dark]: theme === "dark",
          })} onClick={handleIncognitoMode}>
            <div className="flex items-center gap-[16px]">
              <FormattedMessage id="private.chat.navbar" />
              <IncognitoMode />
            </div>
          </div>}

      {/* For chat mode, show RememberTopic with edit icon */}
      {isChat && !isEditing && !PrivateChat &&(
        <div className={classNames(styles.WorkSpace, "flex items-center gap-2 font-inter", {
          [styles.sidebarClose]: !isOpen,
        })}>
          <WorkspaceWrapper maxwidth={false} IsChat={true}>
            <WorkspaceName className={classNames(styles.WorkSpace, {
              [styles.light]: theme === "light",
              [styles.dark]: theme === "dark",
            })}>
              {!RememberTopic && loadChatTopic ? (
                  <div className="flex item-center mt-1"><Loader /></div>
                ) : (
                  removeQuotes(RememberTopic)
                )}
              </WorkspaceName>
              {RememberTopic && (
                <span className="flex items-center cursor-pointer" onClick={handleEditClick}>
                  <WordspaceEditIcon />
                </span>
              )}
            </WorkspaceWrapper>
          </div>
        )}

        {/* For chat mode edit state */}
        {isChat && isEditing && !PrivateChat && (
            <span className={classNames(
              styles.inputWithIcons,
              "flex items-center flex-1 gap-4"
            )}>
              <input
                className={classNames(
                  "flex-grow min-w-0",
                  styles.inputField,
                  {
                    [styles.light]: theme === "light",
                    [styles.dark]: theme === "dark",
                  }
                )}
                type="text"
                value={workspaceName}
                onChange={handleInputChange}
                autoFocus
              />
              <span className={`flex items-center ${width < 860 ? "gap-2" : "gap-4"}`}>
                <div
                  data-testid="confirm-edit-btn"
                  className="cursor-pointer flex flex-row items-center justify-center"
                  onClick={handleEdit}
                >
                  {isLoading ? (
                    <Spinner extraSmall />
                  ) : (
                    <TickIcon EWorkSpace={true} width={20} height={20} />
                  )}
                </div>
                <div
                  data-testid="cancel-edit-btn"
                  className="cursor-pointer flex flex-row items-center justify-center"
                  onClick={() => setIsEditing(false)}
                >
                  <RemoveIcon EWorkSpace={true} width={20} height={20} />
                </div>
              </span>
            </span>
        )}

        {!isHome && !isChat && (includeRoute(RoutePaths.Workspaces) || (workSpace)) && (
          <>
            <span className={classNames(styles.workSpaceName, {
              "hover:underline underline-offset-[3px]": Id,
              [styles.light]: theme === "light",
              [styles.dark]: theme === "dark",
              [styles.cursor]: Id,
            })} onClick={handleRedirectBack}
              data-testid="sidebar-chat-newchat-workspace">
              {renderThreadsContent ?
                selectedThread.ws_name : (workSpace && newMessages.length > 0) && currentConversation?.name
                  ? currentConversation.name
                  : <FormattedMessage id="sidebar.chat.newChat.workspace" />} </span>
            {(Id && width > 576) && (
              <>
                {isEditing ? (
                  <>
                    <span className="text-[#171717] dark:text-[#fff]">/</span>
                    <span
                      className={classNames(
                        styles.inputWithIcons,
                        "flex items-center flex-1 gap-4"
                      )}
                    >
                      <input
                        className={classNames(
                          "flex-grow min-w-0",
                          styles.inputField,
                          {
                            [styles.light]: theme === "light",
                            [styles.dark]: theme === "dark",
                          }
                        )}
                        type="text"
                        value={workspaceName}
                        onChange={handleInputChange}
                        autoFocus
                      />
                      <span className={`flex items-center ${width < 860 ? "gap-2" : "gap-4"}`}>
                        <div
                          data-testid="confirm-edit-btn"
                          className="cursor-pointer flex flex-row items-center justify-center"
                          onClick={handleEdit}
                        >
                          {isLoading ? (
                            <Spinner extraSmall />
                          ) : (
                            <TickIcon EWorkSpace={true} width={20} height={20} />
                          )}
                        </div>
                        <div
                          data-testid="cancel-edit-btn"
                          className="cursor-pointer flex flex-row items-center justify-center"
                          onClick={() => setIsEditing(false)}
                        >
                          <RemoveIcon EWorkSpace={true} width={20} height={20} />
                        </div>
                      </span>
                    </span>
                  </>
                )
                  : (
                    <>
                      <WorkspaceWrapper maxwidth={true}>
                        {(renderThreadsContent || (newMessages?.length > 0)) ? (
                          <>
                            {loadTopicInfo ? (
                              <div className="flex items-center"> <Loader /> </div>
                            ) : (
                              <>
                                {selectedThread.thread_name !== "" && <span className="text-[#171717] dark:text-[#fff]">/</span>}
                                <WorkspaceName className={classNames(styles.WorkSpace, {
                                  [styles.light]: theme === "light",
                                  [styles.dark]: theme === "dark",
                                })}>{removeQuotes(selectedThread.thread_name)}</WorkspaceName>
                                {selectedThread.thread_name !== "" &&
                                  <span className="flex items-center cursor-pointer" onClick={handleEditClick}>
                                    <WordspaceEditIcon />
                                  </span>
                                }
                              </>
                            )}</>) : !currentConversation?.name ? (
                              <div className="flex item-center"><Loader /></div>
                            ) : (
                          <>
                            {currentConversation?.name && <span className="text-[#171717] dark:text-[#fff]">/</span>}
                            <WorkspaceName className={classNames(styles.WorkSpace, {
                              [styles.light]: theme === "light",
                              [styles.dark]: theme === "dark",
                            })}>{removeQuotes(currentConversation?.name)}</WorkspaceName>
                            {currentConversation?.name && <span className="flex items-center cursor-pointer" onClick={handleEditClick}>
                              <WordspaceEditIcon />
                            </span>
                            }
                          </>
                        )}
                      </WorkspaceWrapper>
                    </>
                  )}
              </>
            )}
          </>
        )}
        
        {displayDetail &&  <AlertNotification displayDetail={displayDetail}/> }
      </div >
      {
        isShare ? (
          <div className={styles.shareChatbtn} >
            <Button
              data-testid="share-chat-try-btn"
              className={styles.shareChatTryBtn}
              onClick={() => push(`/${lang}/${RoutePaths.Signup}`)}
            >
              <FormattedMessage id="share.chat.header" />
            </Button>
          </div >
        ) : (
          <>
            <div className={styles.creditsContainer}>
              {!displayDetail && <AlertNotification displayDetail={displayDetail}/> }
              <div
                className={styles.settingIcon}
                onClick={() => setChatSetting!(true)}
                data-testid="chat-setting-icon"
              >
                <Setting />
              </div>
              <div>
                <Credits />
              </div>
            </div>
          </>
        )}
    </>
  );
};